/*

Class : PaymentChoice
Description : Bottom-sheet proposant au vacancier de régler tout de suite par CB
in-app ou sur place (mode "cb_optional" d'un service). Utilisé par Buying (panier
de produits) et Booking (prestations).
Author : Franck David

*/




import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { motion } from 'framer-motion'

class PaymentChoice extends Component {
	render() {
		const assets = this.props.assets
		const themeColor = this.props.themeColor
		// Portail vers document.body : rendu inline, la modal hérite du stacking
		// context de .Wrapper (z-index: 20, voir Main.css) qui passe sous la
		// BottomBar (z-index: 30) — le bouton "Annulé" se retrouvait masqué. Un
		// z-index plus élevé ici n'y change rien tant que l'élément reste piégé
		// dans ce stacking context ; seul un portail en sort vraiment.
		return ReactDOM.createPortal(
			<motion.div
				className="fixed left-0 right-0 top-0 z-50 flex items-end justify-center bg-black bg-opacity-60"
				style={{ bottom: 'calc(var(--vh, 1vh) * 10)' }}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				onClick={this.props.onClose}
			>
				<motion.div
					className="bg-white w-full max-w-md rounded-t-3xl px-6 pt-6"
					style={{ paddingBottom: '10px' }}
					initial={{ y: '100%' }}
					animate={{ y: 0 }}
					exit={{ y: '100%' }}
					transition={{ type: 'spring', stiffness: 300, damping: 30 }}
					onClick={(e) => e.stopPropagation()}
				>
					<div className="flex items-center justify-between mb-1">
						<h2 className="text-xl font-bold text-gray-800">{assets.choice_title}</h2>
						<div className="text-lg font-bold" style={{ color: themeColor }}>{this.props.amountLabel}</div>
					</div>
					<p className="text-sm text-gray-400 mb-5">{assets.choice_subtitle}</p>
					<button
						type="button"
						onClick={this.props.onPayNow}
						className="font-semibold py-4 w-full rounded-full text-white text-base"
						style={{ backgroundColor: themeColor }}
					>
						{assets.pay_now}
					</button>
					<button
						type="button"
						onClick={this.props.onPayOnSite}
						className="font-semibold py-4 w-full rounded-full text-base border-2 text-gray-600 mt-3"
						style={{ borderColor: themeColor }}
					>
						{assets.pay_on_site}
					</button>
					<button
						type="button"
						onClick={this.props.onClose}
						className="font-medium py-3 w-full text-gray-400 text-sm mt-1"
					>
						{assets.cancel}
					</button>
				</motion.div>
			</motion.div>,
			document.body
		)
	}
}

export default PaymentChoice
